import { useEffect } from 'react'

import { GCLID_STORAGE_KEY } from './gclid.constants'

export function useStoreGclid(): void {
  useEffect(() => {
    const gclid = new URLSearchParams(window.location.search).get(GCLID_STORAGE_KEY)

    if (!gclid) return

    try {
      window.sessionStorage.setItem(GCLID_STORAGE_KEY, gclid)
    } catch (error) {}
  }, [])
}
